import React, { Fragment } from "react";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";
import ButtonRounded from "../../../../../../components/ButtonRounded";
import CustomerReqPanel from "./CustomerReqPanel";
import {useCustomerRequirementStyles} from "../../../../../../common/styles/CustomerRequirementStyles";

const useStyles = useCustomerRequirementStyles;

interface CustomerRequirementsProps {
  stepData: any;
  allocateUpdateCustomerReq: any;
  handleNext: () => void;
  handleBack: (() => void) | null;
}

const CustomerRequirements: React.FC<CustomerRequirementsProps> = ({
  stepData,
  allocateUpdateCustomerReq,
  handleBack,
  handleNext,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {Array.isArray(stepData.data) &&
        stepData.data.map((customer: any, index: any) => (
          <Fragment key={index}>
            <CustomerReqPanel
              stepData={stepData}
              data={customer}
              customer={{ id: customer.id, index }}
              allocateUpdateCustomerReq={allocateUpdateCustomerReq}
            />
          </Fragment>
        ))}

      <Grid
        container
        alignItems="center"
        justify="flex-end"
        className={classes.btnContainer}
      >
        <Grid item>
          {handleBack && (
            <ButtonRounded
              variant="contained"
              className={clsx(classes.btn, classes.btnDark)}
              onClick={handleBack}
            >
              Back
            </ButtonRounded>
          )}
          <ButtonRounded
            variant="contained"
            color="primary"
            className={classes.btn}
            onClick={handleNext}
          >
            Next
          </ButtonRounded>
        </Grid>
      </Grid>
    </div>
  );
};

export default CustomerRequirements;
